import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AccountService } from '../services/account.service';
import { Observable } from 'rxjs';
import { PasswordResetOptions } from '../types/PasswordResetOptions';
import { SessionDataService } from '../services/session-data.service';
import { AccountRecoveryUtil } from '../utils/accountrecovery.utils';

@Injectable({
  providedIn: 'root'
})
export class PasswordResetOptionsResolve {
  public constructor(private accountService: AccountService,
    private accountRecoveryUtil: AccountRecoveryUtil,
    private sessionDataService: SessionDataService) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<PasswordResetOptions> {
    if (this.sessionDataService.getUser() && this.sessionDataService.getUser().userName) {
      return this.accountService.lookupPasswordResetOptions(
        this.sessionDataService.getUser(),
        route.params.clientCode,
        this.sessionDataService.getLocale());
    }
    return null;
  }
}
